<template>
  <v-container>
    <v-card flat class="mt-n4 pl-4 pr-4 mb-5" height="300">
      <v-img height="300" :src="'dashboard_back_'+$store.state.CustomInfo.SiteId+'.jpg'" style="z-index: 0; opacity: 0.5;"></v-img>
      <div style="z-index: 1; position: relative; left: 20px; top:-290px">
        <div class="d-flex" style="width: inherit;">
          <v-spacer></v-spacer>
          <img class="slide-top0 mr-12 mt-2" :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height:50px; "/>
        </div>

        <div class="dashboard_menu slide-top1 mt-n5" > Welcome to {{CustomInfo.SiteNm}} </div>
        <div class="dashboard_menu slide-top2" style="cursor: pointer;" @click="isShowGuide1 = true;"> 방문신청은 이렇게 하세요. <v-icon>mdi-chevron-right</v-icon></div>
        <div class="dashboard_menu slide-top3" style="cursor: pointer;" @click="isShowGuide2 = true;"> 방문증 분실 신고는 이렇게 하세요. <v-icon>mdi-chevron-right</v-icon></div>
        <div class="dashboard_menu slide-top4" style="cursor: pointer;" @click="isShowGuide3 = true;"> 업체물품 반입 신청은 이렇게 하세요. <v-icon>mdi-chevron-right</v-icon></div>
        <div class="dashboard_menu slide-top5" v-if="$store.state.CustomInfo.SiteId != 'SKTC' && $store.state.CustomInfo.SiteId != 'SKMP'" style="cursor: pointer;" @click="isShowGuide4 = true;"> 사진촬영 허가는 이렇게 하세요. <v-icon>mdi-chevron-right</v-icon></div>
        <div class="dashboard_menu slide-top5" v-else style="cursor: pointer;" @click="isShowGuide5 = true;"> 카메라 대여 신청은 이렇게 하세요. <v-icon>mdi-chevron-right</v-icon></div>
      </div>
    </v-card>

    <v-row class="ma-0 mt-n5" style="z-index: 0;">
      <!-- sm 이상에서 보이기 -->
      <v-col cols="12" md="6" sm="12" class="hidden-xs-only">
        <v-card class="ma-1 d-flex" flat style="height:290px;background : #F2F2F2;">
          <v-card width="256" outlined class="text-center rounded-r-0" style="background:#8C8C8C;"  >
            <v-card-text>
              <img :src="FilePath" style="width: 100px;height:100px;object-fit: cover;border-radius: 100%;"/>

              <div style="color:white;">{{CustomInfo.CustomNm}}</div>
              <div class="text-caption" style="color:white;">{{CustomInfo.CorpNmKor}}</div>

              <table class="type01 text-center mt-4">
                <tbody>
                  <tr>
                    <td style="color:white; background-color: #6E6E6E;">신청</td>
                    <td style="color:yellow; background-color:#686868;" class="font-weight-black">{{iReqALLQty}}</td>
                  </tr>
                  <tr>
                    <td style="color:white; background-color: #6E6E6E;">승인</td>
                    <td style="color:yellow; background-color:#686868;" class="font-weight-black">{{iOKALLQty}}</td>
                  </tr>
                </tbody>
              </table>
            </v-card-text>
          </v-card>
          <div style="position: relative; height:0px; left:-17px; top:10px;"><v-icon x-large color="#8C8C8C">mdi-menu-right</v-icon></div>
          <v-card flat width="100%" class="ml-n5 pr-3 pt-3" style="background-color:#F2F2F2;">
            <div class="font-weight-black">신청진행현황</div>
            <table class="type03 text-center mt-2" style="font-size:12px;">
              <thead>
                <tr>
                  <!-- <th style="color:#747474; background-color: #DFDFDF;" scope="cols">방문처</th> -->
                  <th style="color:#747474; background-color: #DFDFDF;" scope="cols">구분</th>
                  <th style="color:#747474; background-color: #DFDFDF;" scope="cols">신청일</th>
                  <th style="color:#747474; background-color: #DFDFDF;" scope="cols">진행상태</th>
                </tr>
              </thead>
              <tbody v-if="zALLReqInfo.length != 0" style="z-index:1;">
                <tr style="color:#F2F2F2">
                  <!--
                  <td style="max-width:50px;" align="left">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          style="max-width:60px;min-width:15px;"
                          class="text-truncate"
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{zALLReqInfo[0].cZone}}
                        </div>
                      </template>
                      <div style="max-width:300px !important;">{{zALLReqInfo[0].cZone}}</div>
                    </v-tooltip>
                  </td>
                  -->
                  <td style="text-align: center;">{{GetType(zALLReqInfo[0].cType)}}</td>
                  <td style="text-align: center;">{{zALLReqInfo[0].cCreateDateTime.substring(0,10).replace(/-/g,"/")}}</td>
                  <td style="text-align: center;">{{GetState(zALLReqInfo[0])}}</td>
                </tr>
              </tbody>
            </table>
            <div v-if="zALLReqInfo.length != 0" style="overflow-y:scroll; height:180px;z-index:99;position:relative;top:-18px;">
              <table class="type02 text-center" style="font-size:12px;" >
                <tbody>
                  <tr v-for="(item,index) in zALLReqInfo" :key="index" style="cursor : pointer" @click="GoStatus(item)">
                    <td style="">{{GetType(item.cType)}}</td>
                    <td style="">{{item.cCreateDateTime.substring(0,10).replace(/-/g,"/")}}</td>
                    <td style="">{{GetState(item)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
        </v-card>

        <div class="ma-1">
          <div class="flex-wrap d-flex justify-center">
            <div @click="DownloadGuide()" class="text-center pa-3" style="cursor:pointer">
              <v-icon x-large>mdi-file-document-outline</v-icon>
              <!-- <v-icon x-large>mdi-download</v-icon> -->
              <div class="mt-2">이용자가이드 다운로드</div>
            </div>
            <v-divider vertical class="ma-3"></v-divider>
            <div @click="GoRouter(cSecurityURL)" class="text-center pa-3" style="cursor:pointer">
              <v-icon x-large>mdi-lock</v-icon>
              <div class="mt-2">보안준수사항안내</div>
            </div>
            <v-divider vertical class="ma-3"></v-divider>
            <div @click="ShowPledgeDialog()" class="text-center pa-3" style="cursor:pointer">
              <v-icon x-large>mdi-file-account</v-icon>
              <div class="mt-2">개인정보 처리 방침</div>
            </div>
          </div>
        </div>
      </v-col>

      <!-- xs 이하에서 보이기 -->
      <v-col cols="12" sm="12" md="6" class="d-sm-none">
        <v-card class="ma-1" flat  style="background:#F2F2F2;">
          <!-- <v-card width="100%" outlined class="text-center rounded-r-0" style="background:#8C8C8C;"> -->
          <v-card width="100%" flat class="text-center rounded-r-0 d-flex" style="background-color:#8C8C8C;">
            <v-card flat style="background:#8C8C8C">
              <v-card-text>
                <img :src="FilePath" style="width: 100px;height:100px;object-fit: cover;border-radius: 100%;"/>

                <div style="color:white;">{{CustomInfo.CustomNm}}</div>
                <div class="text-caption" style="color:white;">{{CustomInfo.CorpNmKor}}</div>
              </v-card-text>
            </v-card>
            <v-card flat style="background-color:#8C8C8C;" class="pl-4 pr-4 d-flex align-center">
              <table class="type01 text-center">
                <tbody>
                  <tr>
                    <td style="color:white; background-color: #6E6E6E;">신청</td>
                    <td style="color:yellow; background-color:#686868;" class="font-weight-black">{{iReqALLQty}}</td>
                  </tr>
                  <tr>
                    <td style="color:white; background-color: #6E6E6E;">승인</td>
                    <td style="color:yellow; background-color:#686868;" class="font-weight-black">{{iOKALLQty}}</td>
                  </tr>
                </tbody>
              </table>
            </v-card>
          </v-card>
          <div style="position: relative;top:-17px"><v-icon x-large color="8C8C8C" class="mdi-rotate-90">mdi-menu-right</v-icon></div>
          <v-card flat width="100%" class="pl-4 pr-4" style="background-color:#F2F2F2;">
            <div class="font-weight-black">신청진행현황</div>
            <table class="type03 text-center mt-2" style="font-size:12px;">
              <thead>
                <tr>
                  <th style="color:#747474; background-color: #DFDFDF;" scope="cols">방문처</th>
                  <th style="color:#747474; background-color: #DFDFDF;" scope="cols">신청일</th>
                  <th style="color:#747474; background-color: #DFDFDF;" scope="cols">신청항목</th>
                  <th style="color:#747474; background-color: #DFDFDF;" scope="cols">진행상태</th>
                </tr>
              </thead>
              <tbody v-if="zALLReqInfo.length != 0" style="z-index:1;">
                <tr style="color:#F2F2F2">
                  <td style="max-width:50px;" align="left">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          style="max-width:60px;min-width:15px;"
                          class="text-truncate"
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{zALLReqInfo[0].cZone}}
                        </div>
                      </template>
                      <div style="max-width:300px !important;">{{zALLReqInfo[0].cZone}}</div>
                    </v-tooltip>
                  </td>
                  <td>{{zALLReqInfo[0].cCreateDateTime.substring(0,10).replace(/-/g,"/")}}</td>
                  <td>{{GetType(zALLReqInfo[0].cType)}}</td>
                  <td>{{GetState(zALLReqInfo[0])}}</td>
                </tr>
              </tbody>
            </table>
            <div v-if="zALLReqInfo.length != 0" style="overflow-y:scroll; height:180px;z-index:99;position:relative;top:-18px;">
              <table class="type02 text-center" style="font-size:12px;">
                <tbody>
                  <tr v-for="(item,index) in zALLReqInfo" :key="index" style="cursor : pointer" @click="GoStatus(item)">
                    <td style="max-width:50px;" align="left">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            style="max-width:60px;min-width:15px;"
                            class="text-truncate"
                            v-bind="attrs"
                            v-on="on">
                            {{item.cZone}}
                          </div>
                        </template>
                        <div style="max-width:300px !important;">{{item.cZone}}</div>
                      </v-tooltip>
                    </td>
                    <td style="">{{item.cCreateDateTime.substring(0,10).replace(/-/g,"/")}}</td>
                    <td style="">{{GetType(item.cType)}}</td>
                    <td style="">{{GetState(item)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
        </v-card>

        <div class="ma-1">
          <div class="flex-wrap d-flex justify-center">
            <div class="text-center pa-3" style="cursor:pointer" @click="DownloadGuide()">
              <v-icon x-large>mdi-file-document-outline</v-icon>
              <!-- <v-icon x-large>mdi-download</v-icon> -->
              <div class="mt-2">이용자가이드 다운로드</div>
            </div>   
            <v-divider vertical class="ma-3"></v-divider>
            <div @click="GoRouter(cSecurityURL)" class="text-center pa-3" style="cursor:pointer">
              <v-icon x-large>mdi-lock</v-icon>
              <div class="mt-2">보안준수사항안내</div>
            </div>   
            <v-divider vertical class="ma-3"></v-divider>
            <div @click="ShowPledgeDialog()" class="text-center pa-3" style="cursor:pointer">
              <v-icon x-large>mdi-file-account</v-icon>
              <div class="mt-2">개인정보 처리 방침</div>
            </div>
          </div>
        </div>
      </v-col>

      <v-col cols="12" md="6" sm="12">
        <v-card class="ma-1 mt-1 pa-3" flat outlined>
          <div class="btn_more" ><v-btn @click="GoRouter(cNotiBoardURL)" icon><v-icon>mdi-chevron-right</v-icon></v-btn></div>
          <div class="ml-3" style="border-bottom: 3px solid #333333; width : 100px; padding-bottom:5px; padding-left:20px;">공지사항</div>
          <v-divider class="mb-2 mt-0"></v-divider>
          <div style="height:130px; overflow: hidden;">
            <div v-for="item in zNoticeInfo" :key="item.cNotiBoardId" @click="ShowNotiDialog(item)" class="mt-4 mb-5 ml-3 d-flex text-body-2" style="cursor:pointer">
              <div style="width:inherit; display: block; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{item.cNotiBoardNm}}</div>
              <v-spacer></v-spacer>
              <div style="width:80px; white-space: nowrap;">{{item.cCreateDateTime.substring(0,10)}}</div>
            </div>
          </div>
        </v-card>
        <!-- <v-card class="ma-1 pa-3 mt-2" flat outlined> -->
        <v-card class="ma-1 mt-2 pa-3" flat outlined>
          <div class="btn_more" ><v-btn @click="GoRouter(cFAQURL)" icon><v-icon>mdi-chevron-right</v-icon></v-btn></div>
          <div class="ml-3" style="border-bottom: 3px solid #333333; width : 100px; padding-bottom:5px; padding-left:35px; ">FAQ</div>
          <v-divider class="mb-2 mt-0"></v-divider>
          <div style="height:130px; overflow: hidden;">
            <div v-for="item in zFAQInfo" :key="item.cFAQId" @click="ShowFAQDialog(item)" class="mt-4 mb-5 ml-3 d-flex text-body-2" style="cursor:pointer">
              <div style="width: inherit; display: block; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{item.cFAQNm}}</div>
              <v-spacer></v-spacer>
              <div style="width:80px; white-space: nowrap;">{{item.cCreateDateTime.substring(0,10)}}</div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    

    <v-dialog v-model="isShowGuide1" width="80%">
      <v-card class="pb-4">
        <v-card-title>방문예약 신청 안내 <v-spacer></v-spacer> <v-btn @click="GoRouter('VisitReq')"><v-icon class="mr-2">mdi-pencil-box</v-icon>신청</v-btn></v-card-title>
        <v-divider></v-divider>
        <div class="ma-4">
          - 최소 1일 전에 방문 신청해주셔야 원할한 출입이 가능합니다.<br>
          - 방문증 수령 시에는 신분증, 명함이 필요합니다.
        </div>

        <div class="flex-wrap d-flex justify-center mt-0">
        <img src="../assets/SKST/Guide/guide_1_1.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_1_2.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_1_3.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_1_4.svg" style="height:200px; border-radius: 10px;"/>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isShowGuide2" width="80%">
      <v-card class="pb-4">
        <v-card-title>방문증 분실 신고 안내<v-spacer></v-spacer> <v-btn @click="GoRouter('PassReq')"><v-icon class="mr-2">mdi-pencil-box</v-icon>신청</v-btn></v-card-title>
        <v-divider></v-divider>
        <div class="ma-4">
        </div>
        <div class="flex-wrap d-flex justify-center mt-0">
          <img src="../assets/SKST/Guide/guide_2_1.svg" style="height:200px; border-radius: 10px;"/>
          <img src="../assets/SKST/Guide/guide_2_2.svg" style="height:290px; border-radius: 10px;"/>
          <img src="../assets/SKST/Guide/guide_2_3.svg" style="height:200px; border-radius: 10px;"/>
          <img src="../assets/SKST/Guide/guide_2_4.svg" style="height:200px; border-radius: 10px;"/>
          <img src="../assets/SKST/Guide/guide_2_5.svg" style="height:200px; border-radius: 10px;"/>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isShowGuide3" width="80%">
      <v-card class="pb-4">
        <v-card-title>업체물품 반입 신청 안내 <v-spacer></v-spacer> <v-btn @click="GoRouter('CorCarryReq')"><v-icon class="mr-2">mdi-pencil-box</v-icon>신청</v-btn></v-card-title>
        <v-divider></v-divider>
        <div class="ma-4">
        </div>

        <div class="flex-wrap d-flex justify-center mt-0">
        <img src="../assets/SKST/Guide/guide_3_1.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_3_2.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_3_3.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_3_4.svg" style="height:200px; border-radius: 10px;"/>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isShowGuide4" width="80%">
      <v-card class="pb-4">
        <v-card-title>사진촬영 허가 신청 안내 <v-spacer></v-spacer> <v-btn @click="GoRouter('PictureReq')"><v-icon class="mr-2">mdi-pencil-box</v-icon>신청</v-btn></v-card-title>
        <v-divider></v-divider>
        <div class="ma-4">
        </div>

        <div class="flex-wrap d-flex justify-center mt-0">
        <img src="../assets/SKST/Guide/guide_4_1.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_4_2.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_4_3.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_4_4.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_4_5.svg" style="height:200px; border-radius: 10px;"/>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isShowGuide5" width="80%">
      <v-card class="pb-4">
        <v-card-title>카메라 대여 신청 안내 <v-spacer></v-spacer> <v-btn @click="GoRouter('CameraReq')"><v-icon class="mr-2">mdi-pencil-box</v-icon>신청</v-btn></v-card-title>
        <v-divider></v-divider>
        <div class="ma-4">
        </div>

        <div class="flex-wrap d-flex justify-center mt-0">
        <img src="../assets/SKST/Guide/guide_5_1.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_5_2.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_5_3.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_5_4.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_5_5.svg" style="height:200px; border-radius: 10px;"/>
        </div>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="bAccoutDialog" max-width="600px">
      <v-card>
        <v-card-title class="pa-4 pt-2 pb-2">정산 안내문</v-card-title>
        <v-divider class="mr-4 ml-4"></v-divider>
        <div class="ma-4 mb-0" style="height:calc(90vh - 150px);overflow : auto;max-height:600px;">
          <div class="pa-2 d-flex align-center justify-center">귀사의 방문증 분실에 따른 정산절차를 안내해드립니다.</div>
          <table class="type10 text-center mb-8">
            <thead>
              <tr>
                <th scope="cols"></th>
                <th scope="cols"></th>
                <th scope="cols"></th>
                <th scope="cols"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="4">방문증 세부 금액 내역</td>
              </tr>
              <tr>
                <td>TAG</td>
                <td>카드</td>
                <td>목걸이</td>
                <td>총액</td>
              </tr>
              <tr>
                <td>48,000원</td>
                <td>13,000원</td>
                <td>3,550원</td>
                <td>64,550원</td>
              </tr>
            </tbody>
          </table>
          <div class="pa-2 pt-0 mb-2 d-flex align-center justify-center">분실 신고 현황 내역</div>
          <v-divider></v-divider>
          
          <v-data-table
            :headers="headers"
            :items="zLostResult"
            fixed-header
            hide-default-footer
            style="overflow:auto"
            height="255px">
            <template v-slot:item.cCost="{ item }">
              {{ChangeAmountUnit(item.cCost)}}원
            </template>
            <template v-slot:no-data>
              <div class="black--text">{{cNoMsg}}</div>
            </template>
          </v-data-table>
          <div class="pa-2 d-flex align-center justify-center">합계 {{iCostSum}}원</div>
          <!-- <div class="pa-2 d-flex align-center justify-center">합계 {{sFormatMoneyNum()}}</div> -->
          <div class="pa-2 d-flex align-center justify-center" v-if="$store.state.CustomInfo.SiteId == 'SKST'">은행명: 신한은행, 계좌번호: 100-013-187991, 에스케이스페셜티㈜</div>
          <div class="pa-2 d-flex align-center justify-center" v-if="$store.state.CustomInfo.SiteId == 'SKTC'">은행명: 신한은행, 계좌번호: 140-012-296262, SK트리켐</div>
          <div class="pa-2 d-flex align-center justify-center" v-if="$store.state.CustomInfo.SiteId == 'SKMP'">은행명: 하나은행, 계좌번호: 549-910012-92405, SK머티리얼즈퍼포먼스</div>
          <div class="pa-2 d-flex align-center justify-center" v-if="$store.state.CustomInfo.SiteId == 'SKMJ'">은행명: 하나은행, 계좌번호: 549-910014-78405, SK머티리얼즈제이엔씨</div>
          <div class="pa-2 d-flex align-center justify-center" v-if="$store.state.CustomInfo.SiteId == 'SKMG14'">은행명: 신한은행, 계좌번호: 100-013-187991, SK머티리얼즈그룹14</div>
          <div class="pa-2 d-flex align-center justify-center" v-if="$store.state.CustomInfo.SiteId == 'SKMA'">은행명: 은행, 계좌번호: , SK에어플러스</div>
          <div class="pa-2">
            상기 금액 입금 후 증빙서류(입금증)를 사진 또는 스캔하여 방문증 분실신고 > 방문증 분실 신고 현황 페이지에 가셔서
            해당 방문증 분실 신고서를 클릭한 후 증빙서류로 첨부하여 주시기 바랍니다.<br>
          </div>
          <div class="pa-2">
            보안담당자의 확인 과정을 거친 후 방문증 분실 신고 절차가 종결되면 SMS로 종결 안내문이 발송됩니다.
          </div>
          <v-card-text class="text-subtitle-1 text-sm-h5 grey--text text--darken-3 text-center " style="height:60px;">
            {{$store.state.CustomInfo.SiteNm}} 주식회사
          </v-card-text>
        </div>
        <div class="ma-4 mb-0">
          <v-divider class="mt-4"></v-divider>
          <div class="d-flex align-center justify-end pt-2 pb-2">
            <v-checkbox v-model="bNoShowPassAgain" class="mt-0 pt-0 mr-2" color="black" hide-details>
              <template v-slot:label>
                <div class="black--text">
                  다시 보지 않기
                </div>
              </template>
            </v-checkbox>
            <v-spacer></v-spacer>
            <v-btn @click="CloseAccoutDialog()" color="black" text><v-icon>mdi-close</v-icon>닫기</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="bPenaltyDialog" max-width="600px">
      <v-card>
        <v-card-title class="pa-4 pt-2 pb-2">보안 규정 위반 안내문</v-card-title>
        <v-divider class="mr-4 ml-4"></v-divider>
        <div v-if="cPenaltyType != 'XC'" class="ma-4 mb-0" style="height:calc(90vh - 150px);overflow : auto;max-height:600px;">
          <div class="pa-2">
            귀하는 보안규정 위반으로 {{formatPenaltyType}} 조치 되었습니다.
          </div>
          <div class="pa-2">
            자세한 사항은 보안규정위반내역 페이지에서 확인 바랍니다.
          </div>
          <div v-if="!(cPenaltyType == 'W' || cPenaltyType == 'X')" class="pa-2">
            출입 정지 기간 : {{cStartDate}} ~ {{cEndDate}}<br>
            {{formatPenaltyType}}는 {{formatEndDate}} 까지 제출하여 주세요
          </div>
        </div>
        <div v-else class="ma-4 mb-0" style="height:calc(90vh - 150px);overflow : auto;max-height:600px;">
          <div class="pa-2">
            귀하는 {{formatPenaltyType}} 조치 되었습니다.
          </div>
          <div class="pa-2">
            자세한 사항은 보안규정위반내역 페이지에서 확인 바랍니다.
          </div>
        </div>
        <div class="ma-4 mb-0">
          <v-divider class="mt-4"></v-divider>
          <div class="d-flex align-center justify-end pt-2 pb-2">
            <v-checkbox v-model="bNoShowPenaltyAgain" class="mt-0 pt-0 mr-2" color="black" hide-details>
              <template v-slot:label>
                <div class="black--text">
                  다시 보지 않기
                </div>
              </template>
            </v-checkbox>
            <v-spacer></v-spacer>
            <v-btn @click="ClosePenaltyDialog()" color="black" text><v-icon>mdi-close</v-icon>닫기</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <FAQDialog ref="FAQDialogRef"/>
    <BoardDialog ref="BoardDialogRef"/>
    <PledgeDialog ref="PledgeDialogRef"/>

  </v-container>
</template>

<script>
import { mapState } from "vuex";
import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';

import FAQDialog from "../components/FAQDialog.vue";
import BoardDialog from "../components/BoardDialog.vue";
import PledgeDialog from "../components/PledgeDialog.vue";

import Util from '../Util.js';

export default {
  components: {
    FAQDialog,
    BoardDialog,
    PledgeDialog,
  },

  data: () => ({
    bNoShowOpenNotiAgain : false,

    isShowGuide1 : false,
    isShowGuide2 : false,
    isShowGuide3 : false,
    isShowGuide4 : false,
    isShowGuide5 : false,

    bAccoutDialog : false,
    bPenaltyDialog : false,
    bNoShowPassAgain : false,
    bNoShowPenaltyAgain : false,

    cStartDate : "",
    cEndDate : "",
    cPenaltyType : "",

    iReqInQty : 0,
    iOKInQty : 0,
    iReqPassQty : 0,
    iOKPassQty : 0,
    iReqGoodQty : 0,
    iOKGoodQty : 0,
    iReqCameraQty : 0,
    iOKCameraQty : 0,
    iReqMoveCorpQty : 0,
    iOKMoveCorpQty : 0,
    iReqChangeManagerQty : 0,
    iOKChangeManagerQty : 0,

    iReqALLQty : 0,
    iOKALLQty : 0,

    cFAQURL : "/FAQ",
    cNotiBoardURL : "/NoticeBoard",
    cSecurityURL : "/Security",
    cVisitStatusURL : "/VisitStatus",
    cPassStatusURL : "/PassStatus",
    cPictureStatusURL : "/PictureStatus",
    cCorCarryStatusURL : "/CorCarryStatus",
    cMoveCompanyURL : "/MoveCompany",
    cChangeCorpMangerURL : "/ChangeCorpManger",
    cNoMsg : "",
    FilePath : "",
    cWorkCount : "",
    iCostSum : "0",
    zNoticeInfo : [],
    zNoticePopUpInfo : [],
    zFAQInfo : [],
    zALLReqInfo : [],
    zLostResult : [],
    headers : [
      { text: '방문증 번호', align: 'center', value: 'cRf',width : "10"},
      { text: '분실자 이름', value: 'cCustomNm',width: "120",align: 'center'},
      { text: '분실 일자', value: 'cLostDateTime',align: 'center'},
      { text: '금액', value: 'cCost',align: 'center'},
    ],
  }),

  computed: {
    formatPenaltyType() {
      if (this.cPenaltyType == "W") {
        return "경고"
      } else if (this.cPenaltyType == "WC" || this.cPenaltyType == "C") {
        return "위반 사유서"
      } else if (this.cPenaltyType == "CO" || this.cPenaltyType == "O") {
        return "위반 공문"
      } else if (this.cPenaltyType == "X") {
        return "영구 출입 정지"
      } else if (this.cPenaltyType == "XC") {
        return "영구 출입 정지 취소"
      } else {
        return ""
      }
    },
    formatEndDate() {
      const today = new Date(this.cStartDate);

      if (today.getFullYear() % 4 == 0) {
        today.setDate(today.getDate() + 13)
      } else {
        today.setDate(today.getDate() + 14)
      }
      return Util.sFormatDate(today)
    },
    ...mapState(["CustomInfo","zState","zPassCardState","zCarryState","zPicState","zDefaultState"]),
  },
  
  mounted () {
    this.bAccoutDialog = false
    this.bNoShowPassAgain = false
    this.bNoShowPenaltyAgain = false
    this.GetMainBoardContent();
    this.FilePath = process.env.VUE_APP_FILE_API + this.CustomInfo.Path
  },

  methods: {
    CloseOpenNoti() {
      if (this.bNoShowOpenNotiAgain) {
        localStorage.setItem("bNoShowOpenNotiAgain","Y")
      } else {
        localStorage.setItem("bNoShowOpenNotiAgain","N")
      }
    },

    goMenu(iIdx){
      if (iIdx == 1) {
        this.isShowGuide1 = true;
      } else if (iIdx == 2) {
        this.isShowGuide1 = true;
      } else if (iIdx == 3) {
        this.isShowGuide2 = true;
      } else if (iIdx == 4) {
        this.isShowGuide3 = true;
      } else if (iIdx == 5) {
        this.isShowGuide4 = true;
      }
    },

    // 현황판 이동하기
    GoStatus(item){
      if (item.cType == BasicInfo.REQ_TYPE_VISIT) {
        this.$router.push({path : this.cVisitStatusURL})
      } else if (item.cType == BasicInfo.REQ_TYPE_PASS) {
        this.$router.push({path : this.cPassStatusURL})
      } else if (item.cType == BasicInfo.REQ_TYPE_PHOTO) {
        this.$router.push({path : this.cPictureStatusURL})
      } else if (item.cType == BasicInfo.REQ_TYPE_CARRY) {
        this.$router.push({path : this.cCorCarryStatusURL})
      } else if (item.cType == BasicInfo.REQ_TYPE_MOVE) {
        this.$router.push({path : this.cMoveCompanyURL})
      } else if (item.cType == BasicInfo.REQ_TYPE_CMNG) {
        this.$router.push({path : this.cChangeCorpMangerURL})
      }
    },

    GetType(Type) {
      if (Type == BasicInfo.REQ_TYPE_VISIT) {
        return "방문예약"
      } else if (Type == BasicInfo.REQ_TYPE_PASS) {
        return "분실신고"
      } else if (Type == BasicInfo.REQ_TYPE_PHOTO) {
        return "사진촬영"
      } else if (Type == BasicInfo.REQ_TYPE_CARRY) {
        return "물품반입"
      } else if (Type == BasicInfo.REQ_TYPE_MOVE) {
        return "업체변경"
      } else if (Type == BasicInfo.REQ_TYPE_CMNG) {
        return "관리자변경"
      }
    },

    GetState(item) {
      if (item.cType == BasicInfo.REQ_TYPE_VISIT) {
        return this.zState.find((e) => {return e.value == item.cState})?.text
      } else if (item.cType == BasicInfo.REQ_TYPE_PASS) {
        return this.zPassCardState.find((e) => {return e.value == item.cState})?.text
      } else if (item.cType == BasicInfo.REQ_TYPE_PHOTO) {
        return this.zPicState.find((e) => {return e.value == item.cState})?.text
      } else if (item.cType == BasicInfo.REQ_TYPE_CARRY) {
        return this.zCarryState.find((e) => {return e.value == item.cState})?.text
      } else {
        return this.zDefaultState.find((e) => {return e.value == item.cState})?.text
      }
    },

    ShowPopUpNotiDialog(){      
      if (this.zNoticePopUpInfo.length == 0) {
        // localStorage.removeItem("cPopUpInfo")
      } else {        
        if (localStorage.getItem("cPopUpInfo") == undefined) {
          this.$refs.BoardDialogRef.ShowDialog(true,this.zNoticePopUpInfo,[])
        } else {
          var zBoarPopupInfo = []
          const oNoPopUpInfo = JSON.parse(localStorage.getItem("cPopUpInfo"));

          for (let i = 0; i < this.zNoticePopUpInfo.length;i++) {
            let iDelIndex2 = oNoPopUpInfo.filter((item) => {
              return item == this.zNoticePopUpInfo[i].cNotiBoardId ? true : false;
            });
            if (iDelIndex2.length == 0) {
              this.zNoticePopUpInfo[i].bNoShow = false;
              zBoarPopupInfo.push(this.zNoticePopUpInfo[i])
            }
          }

          if (zBoarPopupInfo.length > 0) {            
            this.$refs.BoardDialogRef.ShowDialog(true,zBoarPopupInfo,oNoPopUpInfo)
          }
        }
      }
    },

    async ShowNotiDialog(item){
      let res = await this.SetNotiboardCount(item.cNotiBoardId)

      if (res.data.ResultCd == "00") {
        item.iShowCount =  res.data.Result[0].iShowCount
        this.$refs.BoardDialogRef.ShowDialog(false,[item])
      } else {
        EventBus.$emit("onShowMsg",true, res.data.Msg);
      }
    },

    // 조회수 증가시키기
    SetNotiboardCount(cNotiBoardId){
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        NotiBoardId : cNotiBoardId,
      }
      return new Promise((resolve) => (
        axios
        .post(process.env.VUE_APP_UIL_API + "SetNotiboardCount", posData, {
          headers: {
            "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          resolve(res);
        })
        .catch(err => {
          resolve(null);
          EventBus.$emit("onShowMsg", true,""+err);
        })
      ));
    },

    // FAQ 다이올로그 창 열기
    async ShowFAQDialog(item){
      let res = await this.SetFaqCount(item.cFAQId)

      if (res.data.ResultCd == "00") {
        item.iShowCount =  res.data.Result[0].iShowCount
        this.$refs.FAQDialogRef.ShowDialog(item)
      } else {
        EventBus.$emit("onShowMsg",true, res.data.Msg);
      }
    },

    // 조회수 증가시키기
    SetFaqCount(cFAQId){
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        FAQId : cFAQId,
      }
      return new Promise((resolve) => (
        axios
        .post(process.env.VUE_APP_UIL_API + "SetFaqCount", posData, {
          headers: {
            "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          resolve(res);
        })
        .catch(err => {
          resolve(null);
          EventBus.$emit("onShowMsg", true,""+err);
        })
      ));
    },

    // FAQ 다이올로그 창 열기
    ShowPledgeDialog(){
      this.$refs.PledgeDialogRef.ShowDialog("A0007", "")
    },

    ChangeAmountUnit(iSum){
      return iSum.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    },

    // 모든 정보 가져오기
    GetMainBoardContent() {
      this.zLostResult = []
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
      }

      axios
        .post(process.env.VUE_APP_UIL_API + "GetMainBoardContent", posData , {
            headers: {
             "Authorization": this.CustomInfo.Token
            }
          })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            for (let i = 0; i< res.data.Result1.length; i ++) {
              if (res.data.Result1[i].cType == BasicInfo.REQ_TYPE_VISIT && res.data.Result1[i].cState == "OK"){
                this.iOKInQty += 1
              } else if (res.data.Result1[i].cType == BasicInfo.REQ_TYPE_PASS && res.data.Result1[i].cState == "O") {
                this.iOKPassQty += 1
              } else if (res.data.Result1[i].cType == BasicInfo.REQ_TYPE_CARRY && res.data.Result1[i].cState == "O") {
                this.iOKGoodQty += 1
              } else if (res.data.Result1[i].cType == BasicInfo.REQ_TYPE_PHOTO && res.data.Result1[i].cState == "A") {
                this.iOKCameraQty += 1
              } else if (res.data.Result1[i].cType == BasicInfo.REQ_TYPE_MOVE && res.data.Result1[i].cState == "O") {
                this.iOKMoveCorpQty += 1
              } else if (res.data.Result1[i].cType == BasicInfo.REQ_TYPE_CMNG && res.data.Result1[i].cState == "O") {
                this.iOKChangeManagerQty += 1
              }
            }

            this.iOKALLQty = this.iOKInQty + this.iOKPassQty + this.iOKGoodQty + this.iOKCameraQty + this.iOKMoveCorpQty + this.iOKChangeManagerQty
            this.iReqALLQty = res.data.Result1.length
            this.zALLReqInfo = res.data.Result1
            
            if (res.data.Result2.length > 0) {
              let CheckDate = Util.sFormatDate(new Date())
              for (let i = 0; i < res.data.Result2.length; i ++) {
                if (res.data.Result2[i].cPopup == "Y" && (res.data.Result2[i].cPopupStartDate <= CheckDate) && (res.data.Result2[i].cPopupEndDate >= CheckDate)) {
                  this.zNoticePopUpInfo.push(res.data.Result2[i])
                }
                this.zNoticeInfo.push(res.data.Result2[i])
              }
            }

            if (res.data.Result3.length <4) {
              this.zFAQInfo = res.data.Result3
            } else {
              for (let i = 0; i < 3; i ++) {
                this.zFAQInfo.push(res.data.Result3[i])
              }
            }

            this.iCostSum = "0"
            if (res.data.Result4.length > 0) {
              this.cWorkCount = res.data.Result4.length
              this.zLostResult = res.data.Result4
              let cCostSum = 0
              for (let i = 0; i < res.data.Result4.length; i ++) {
                cCostSum += Number(res.data.Result4[i].cCost)
              }

              this.iCostSum = this.ChangeAmountUnit(cCostSum)

              this.bAccoutDialog = false
              for (let i = 0; i < res.data.Result4.length; i ++) {
                if (res.data.Result4[i].cNoShow == "N") {
                  this.bAccoutDialog = true
                  break
                }
              }
            } else {
              this.cWorkCount = 0
              this.cNoMsg = ""
              setTimeout(() => {
                this.cNoMsg = "신청된 내역이 없습니다."
              }, 300);
            }

            // if (res.data.Result5[0].cPenaltyType != "" && res.data.Result5[0].cSuspensionDate >= Util.sFormatDate(new Date()) && res.data.Result5[0].cNoShowPenalty == "N") {
            if (res.data.Result5[0].cPenaltyType != "" && res.data.Result5[0].cNoShowPenalty == "N") {
              this.cStartDate = res.data.Result5[0].cSuspensionStartDate
              this.cEndDate = res.data.Result5[0].cSuspensionDate
              this.cPenaltyType = res.data.Result5[0].cPenaltyType
              this.bPenaltyDialog = true;
            }

            this.ShowPopUpNotiDialog();
          } else {
            EventBus.$emit("onShowMsg",true, res.data.Msg);
          }
        })
        .catch(err =>{
          EventBus.$emit("onShowMsg",true, err);
        }) 
    },

    DownloadGuide() {
      axios({
        url: process.env.VUE_APP_FILE_API + "Files/CustomGuide_"+ this.$store.state.CustomInfo.SiteId + ".pdf",
        method: 'GET',
        responseType: 'blob',
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'CustomGuide.pdf');
          document.body.appendChild(link);
          link.click();
        });
    },

    // 화면 이동하기
    GoRouter(sURL){
      this.$router.push({path: sURL});
    },

    CloseAccoutDialog(){
      if (this.bNoShowPassAgain) {
        this.SetNoShowChange()
      } else {
        this.bAccoutDialog = false
        return
      }
    },

    SetNoShowChange() {
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
      }

      axios
        .post(process.env.VUE_APP_UIL_API + "SetNoShowChange", posData , {
            headers: {
             "Authorization": this.CustomInfo.Token
            }
          })
        .then(res => {
          this.bAccoutDialog = false
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "02") {
            this.$store.dispatch('logout',"DelCustomId");
            EventBus.$emit("onShowMsgBox","이미 삭제된 아이디 입니다.","로그인 화면으로 이동합니다.");
          }
        })
        .catch(err =>{
          if (!err) {this.bAccoutDialog = false}
          // EventBus.$emit("onShowMsg",true, err);
        })
    },

    ClosePenaltyDialog(){
      if (this.bNoShowPenaltyAgain) {
        this.SetNoShowPenalty()
      } else {
        this.bPenaltyDialog = false
        return
      }
    },

    SetNoShowPenalty() {
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
      }

      axios
        .post(process.env.VUE_APP_UIL_API + "SetNoShowPenalty", posData , {
            headers: {
             "Authorization": this.CustomInfo.Token
            }
          })
        .then(res => {
          this.bPenaltyDialog = false
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "02") {
            this.$store.dispatch('logout',"DelCustomId");
            EventBus.$emit("onShowMsgBox","이미 삭제된 아이디 입니다.","로그인 화면으로 이동합니다.");
          }
        })
        .catch(err =>{
          if (!err) {this.bPenaltyDialog = false}
          // EventBus.$emit("onShowMsg",true, err);
        }) 
    },
  }
};
</script>

<style scoped>
  .flip-in-ver-right {
    -webkit-animation: flip-in-ver-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 0.5s;
    animation: flip-in-ver-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 0.5s;
  }
  .flip-in-ver-right1 {
    -webkit-animation: flip-in-ver-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 0.75s;
    animation: flip-in-ver-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 0.75s;
  }
  .flip-in-ver-right2 {
    -webkit-animation: flip-in-ver-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 1s;
    animation: flip-in-ver-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 1s;
  }
  .flip-in-ver-right3 {
    -webkit-animation: flip-in-ver-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 1.25s;
    animation: flip-in-ver-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 1.25s;
  }

@-webkit-keyframes flip-in-ver-right {
  0% {
    -webkit-transform: rotateY(-80deg);
            transform: rotateY(-80deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: rotateY(0);
            transform: rotateY(0);
    opacity: 1;
  }
}
@keyframes flip-in-ver-right {
  0% {
    -webkit-transform: rotateY(-80deg);
            transform: rotateY(-80deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: rotateY(0);
            transform: rotateY(0);
    opacity: 1;
  }
}

  .btn_more{
    z-index: 1;
    position:relative; 
    height:0px;
    top:-5px;
    float: right;
  }

  .box_ing {
    width : 100px;
    background: #FFFFFF;
    border-radius: 10px;
    box-shadow: 0px 0px 10px #00000022;
  }


  table.type01 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type01 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type01 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type01 td {
    width: 350px;
    padding: 10px;
    vertical-align:center;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }

  table.type03 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : calc(100% - 12px);
  }

  /* 헤더 부분의 CSS */
  table.type03 thead th {
    padding: 10px;
    font-weight: bold;  /* 없어도 적용 가능 */
    vertical-align: center;
    border-bottom: 2px solid rgb(141, 141, 141);
  }

  table.type03 tbody {
    color: #f3f6f7;
  }


  /* 헤더 부분의 CSS */
  table.type02 thead th {
    padding: 10px;
    font-weight: bold;  /* 없어도 적용 가능 */
    vertical-align: center;
    border-bottom: 2px solid rgb(141, 141, 141);
  }

  /* font-weight 없어도 CSS가 변화가 없는 듯 함 */
  table.type02 tbody th {
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }

  /* 헤더와 바디 부분의 각각의 칸(행)들 */
  table.type02 td {
    padding: 10px;
    vertical-align:center;
    text-align: center;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }

  table.type02 tbody td {
    width: 120px; 
    padding-right: 40px;
  }

  /* 신청일 부분만 */
  table.type02 tbody td:nth-child(2) {
    padding-right: 70px;
  }
   
  table.type02 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }

  /* 헤더 부분의 CSS */
  table.type02 thead th {
    padding: 10px;
    font-weight: bold;  /* 없어도 적용 가능 */
    vertical-align: center;
    border-bottom: 2px solid rgb(141, 141, 141);
  }

  /* font-weight 없어도 CSS가 변화가 없는 듯 함 */
  table.type02 tbody th {
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }

  /* 헤더와 바디 부분의 각각의 칸(행)들 */
  table.type02 td {
    padding: 10px;
    vertical-align:center;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }

  table.type10 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type10 thead th {
    padding-top: 0px;
    padding-bottom: 10px;
    font-weight: bold;
    vertical-align: top;
    /* border-bottom: 2px solid rgb(141, 141, 141); */
  }
  table.type10 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type10 td {
    width: 350px;
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }
  .dashboard_menu {
    height : 50px; 
    width:300px; 
    background:#FFFFFFBB; 
    padding-top: 13px; 
    padding-left: 13px; 
    border-bottom: 1px solid #80808060;
    border-right: 1px solid #80808060;
  }

  .slide-top0 {
    -webkit-animation: slide-top 5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 0.3s;
    animation: slide-left 5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 0.3s;
    animation-iteration-count: 2;
  }
  .slide-top1 {
    -webkit-animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 0.3s;
    animation: slide-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 0.3s;
  }
  .slide-top2 {
    -webkit-animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 0.8s;
    animation: slide-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 0.8s;
  }
  .slide-top3 {
    -webkit-animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 1s;
    animation: slide-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 1s;
  }
  .slide-top4 {
    -webkit-animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 1.2s;
    animation: slide-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 1.2s;
  }
  .slide-top5 {
    -webkit-animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 1.4s;
    animation: slide-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 1.4s;
  }

  
 </style>